import React from 'react';
import { queries } from '../../graphql/graphql';

import LoggedLayout from '../../components/Layouts/LoggedLayout';
import List from '../../containers/List';
import { CustomCard } from '../../components/PlansList/PlanListCard';

const ListPage = () => (
  <LoggedLayout>
    <List
      prefix="plans-list"
      queries={queries.MAP_RESULTS}
      canCreate={false}
      editable={false}
      CustomCard={CustomCard}
    />
  </LoggedLayout>
);

export default ListPage;
